import { Action } from 'redux';

import { SetAndSavePreviousFilterPanelVisibility, SetFromPreviousFilterPanelVisibilty, UpdateExplorerDisplayMode, UpdateExplorerDisplayModeInternal, UpdateFilterPanelVisibility } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { DisplayMode } from '../../sessionManagement/serverApi/types/ISessionInfo';

/* UpdateExplorerDisplayMode */

export interface UpdateExplorerDisplayModeAction extends Action {
  type: typeof UpdateExplorerDisplayMode;
  explorerDisplayMode: DisplayMode;
  saveToServer: boolean;
}

export function updateExplorerDisplayMode(explorerDisplayMode: DisplayMode, saveToServer: boolean): UpdateExplorerDisplayModeAction {
  return {
    type: UpdateExplorerDisplayMode,
    explorerDisplayMode,
    saveToServer
  };
}

export const isUpdateExplorerDisplayModeAction = isActionFactory<UpdateExplorerDisplayModeAction>(UpdateExplorerDisplayMode);


/* UpdateExplorerDisplayMode in state -- this is an internal action, dispatched by the saga that handles UpdateExplorerDisplayMode */

export interface UpdateExplorerDisplayModeInternalAction extends Action {
  type: typeof UpdateExplorerDisplayModeInternal;
  explorerDisplayMode: DisplayMode;
}

export function updateExplorerDisplayModeInternal(explorerDisplayMode: DisplayMode): UpdateExplorerDisplayModeInternalAction {
  return {
    type: UpdateExplorerDisplayModeInternal,
    explorerDisplayMode
  };
}

export const isUpdateExplorerDisplayModeInternalAction = isActionFactory<UpdateExplorerDisplayModeInternalAction>(UpdateExplorerDisplayModeInternal);


/* UpdateFilterPanelVisibility */

export interface UpdateFilterPanelVisibilityAction extends Action {
  type: typeof UpdateFilterPanelVisibility;
  showFilterPanel: boolean;
}

export function updateFilterPanelVisibility(showFilterPanel: boolean): UpdateFilterPanelVisibilityAction {
  return {
    type: UpdateFilterPanelVisibility,
    showFilterPanel
  };
}

export const isUpdateFilterPanelVisibilityAction = isActionFactory<UpdateFilterPanelVisibilityAction>(UpdateFilterPanelVisibility);


/* SetAndSavePreviousFilterPanelVisibility */

export interface SetAndSavePreviousFilterPanelVisibilityAction extends Action {
  showFilterPanel: boolean;
}

export function setAndSavePreviousFilterPanelVisibility(showFilterPanel: boolean): SetAndSavePreviousFilterPanelVisibilityAction {
  return {
    type: SetAndSavePreviousFilterPanelVisibility,
    showFilterPanel
  };
}

export const isSetAndSavePreviousFilterPanelVisibilityAction = isActionFactory<SetAndSavePreviousFilterPanelVisibilityAction>(SetAndSavePreviousFilterPanelVisibility);

/* SetFromPreviousFilterPanelVisibilty */

export interface SetFromPreviousFilterPanelVisibiltyAction extends Action {}

export function setFromPreviousFilterPanelVisibilty(): SetFromPreviousFilterPanelVisibiltyAction {
  return {
    type: SetFromPreviousFilterPanelVisibilty,
  };
}

export const isSetFromPreviousFilterPanelVisibiltyAction = isActionFactory<SetFromPreviousFilterPanelVisibiltyAction>(SetFromPreviousFilterPanelVisibilty);
